module.exports = {
          srcSet: __webpack_public_path__ + "5772a4b39e9c22942d96ec5ebae85872-1024.png"+" 1024w",
          images:[ {path: __webpack_public_path__ + "5772a4b39e9c22942d96ec5ebae85872-1024.png",width: 1024,height: 246}],
          src: __webpack_public_path__ + "5772a4b39e9c22942d96ec5ebae85872-1024.png",
          toString:function(){return __webpack_public_path__ + "5772a4b39e9c22942d96ec5ebae85872-1024.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAATElEQVR4nAXBIQ7CQABE0Zm7VCBI0wQJCktITc0icDNcgrPv73tS58/lr7IpPBxuLneXp8NVZVW4SJmLwtdB6txdhsvH5XB4u7wUxgk/4SEuaYTwEQAAAABJRU5ErkJggg==",
          width: 1024,
          height: 246
        }